import React from 'react';
import { Breadcrumb, Avatar, Badge } from 'antd';
import { HomeOutlined, BellOutlined, UserOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 10px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  background: white;
  padding: 8px 15px;
  border-radius: 99px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const DashboardHeader = ({ userName, profileImage, children }) => {
    return (
        <HeaderSection>
            <BreadcrumbWrapper>
                <HomeOutlined style={{ color: '#00c2ff', fontSize: 18 }} />
                <Breadcrumb
                    separator=">"
                    items={[
                        { title: <span style={{ color: '#00c2ff', fontWeight: 600 }}>DASHBOARD</span> },
                    ]}
                />
            </BreadcrumbWrapper>

            <HeaderControls>
                {children}
                <ProfileSection>
                    <Badge dot offset={[-2, 2]} color="green">
                        <BellOutlined style={{ fontSize: 20, color: '#00c2ff' }} />
                    </Badge>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{userName}</div>
                    </div>
                    <Avatar
                        size={40}
                        src={profileImage}
                        icon={<UserOutlined />}
                        style={{ border: '2px solid #00c2ff' }}
                    />
                </ProfileSection>
            </HeaderControls>
        </HeaderSection>
    );
};

export default DashboardHeader;
